// extracted by mini-css-extract-plugin
export var copyIcon = "_ro-2";
export var discountCard = "_ro-0";
export var discountCode = "_ro-3";
export var discountContent = "_ro-1";
export var loadingCard = "_ro-4";